import { createVuetify } from "vuetify";
import { PreferenceStore } from "../components/Editor/services/preference-store";

const light = PreferenceStore.INSTANCE.lightTheme;
const dark = PreferenceStore.INSTANCE.darkTheme;

// Vuetify
import "@/styles/main.scss";
import { VAvatar, VMenu, VContainer, VImg, VBtn, VCard } from "vuetify/components";

export default createVuetify({
  //All vuetify components that are required from the platform web components
  // must be imported here, since they will be removed from the bundle by tree shaking otherwise
  components: {
    VAvatar,
    VMenu,
    VContainer,
    VImg,
    VBtn,
    VCard,
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: light.app.primary,
          surface: light.app.surface,
          toolbar: light.app["toolbar"],
          accent: light.app.accent,
          background: light.app.background,
          success: light.app.success,
          error: light.app.error,
          warning: light.app.warning,
          information: light.app.information,
          "info-progress": light.app["info-progress"],
          "contrast-grey-low": light.app["contrast-grey-low"],
          "contrast-grey-medium": light.app["contrast-grey-medium"],
          "contrast-grey-high": light.app["contrast-grey-high"],
          white: light.app.white,
          font: light.app.font,
          fontStatusBar: light.app.fontStatusBar,
          "on-background": light.app.font,
          "on-accent": light.app["on-accent"],
          // on some components with specific combinations of using them,
          // vuetify owned double name colors like "on-surface" are not applied properly
          // -> so better don't use them and use e.g. font instead of "on-surface"
          "on-surface": light.app["on-surface"],
          "on-surface-variant": light.app["on-surface-variant"],
          "on-primary": light.app["surface"],
          "on-secondary": light.app["surface"],
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: dark.app.primary,
          surface: dark.app.surface,
          toolbar: dark.app["toolbar"],
          accent: dark.app.accent,
          background: dark.app.background,
          success: dark.app.success,
          error: dark.app.error,
          warning: dark.app.warning,
          information: dark.app.information,
          "info-progress": dark.app["info-progress"],
          "contrast-grey-low": dark.app["contrast-grey-low"],
          "contrast-grey-medium": dark.app["contrast-grey-medium"],
          "contrast-grey-high": dark.app["contrast-grey-high"],
          white: dark.app.white,
          font: dark.app.font,
          fontStatusBar: dark.app.fontStatusBar,
          "on-background": dark.app["font"],
          "on-accent": dark.app["on-accent"],
          "on-surface": dark.app["on-surface"],
          "on-surface-variant": dark.app["on-surface-variant"],
          "on-primary": dark.app["surface"],
          "on-secondary": dark.app["surface"],
        },
      },
    },
  },
  aliases: {
    VBtnPrimary: VBtn,
    VBtnAccent: VBtn,
    VBtnIcon: VBtn,
    VBtnDialogAction: VBtn,
    VBtnDialogActionCTA: VBtn,
    VBtnDeleteAction: VBtn,
    VBtnDeleteActionCTA: VBtn,
  },
  defaults: {
    VBtn: {
      variant: "elevated",
    },
    VToolbar: {
      color: "contrast-grey-low",
    },
    VBtnPrimary: {
      color: "primary",
      variant: "elevated",
    },
    VBtnAccent: {
      color: "accent",
      variant: "elevated",
    },
    VBtnIcon: {
      color: "font",
      variant: "text",
    },
    VBtnDialogAction: {
      color: "primary",
      variant: "outlined",
      class: "base-dialog-action-button",
    },
    VBtnDialogActionCTA: {
      color: "primary",
      variant: "elevated",
      class: "base-dialog-action-button",
    },
    VBtnDeleteAction: {
      color: "font",
      variant: "outlined",
      class: "base-dialog-action-button",
    },
    VBtnDeleteActionCTA: {
      color: "error",
      variant: "elevated",
      class: "base-dialog-action-button",
    },
  },
});
